import * as React from 'react';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, Box, Typography, OutlinedInput, InputAdornment } from '@mui/material';
import CloseIcon from 'app/components/Icons/CloseIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import {
  btnsBox,
  closeBtn,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  inputHeader,
  inputOutlined,
  paperProps,
  selectStyles,
  smallScreenBtnBox,
  btnFilter,
  notif,
  notifText,
} from './Filter.sx';
import AmountInput from 'app/components/Filter/AmountInput';
import useFilter from 'app/components/Filter/useFilter';
import CalendarIcon from 'app/components/Icons/CalendarIcon';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { OptionsWithIcon } from 'app/components/SelectOption';
import FilterIcon from 'app/components/Icons/FilterIcon';
import CustomSelect from 'app/components/CustomSelect';
import FieldError from "app/components/FieldError";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;

interface Props {
  pageName?: string;
  selectedAccount?: string;
  bg?: boolean;
  paymentType?: any;
  btnId?: number;
  setPaymentType?: any;
  voen?: any;
  setVoen?: any;
  client?: any;
  setClient?: any;
  selectedPeriod?: any;
  setSelectedPeriod?: any;
  resNextDate?: any;
  setNextResDate?: any;
  resEndDate?: any;
  setEndResDate?: any;
  fromAmount?: any;
  setFromAmount?: any;
  toAmount?: any;
  setToAmount?: any;
  filterCounter?: any;
  setFilterCounter?: any;
  showCount?: any;
  setShowCount?: any;
  mainCount?: any;
  setMainCount?: any;
  showFilter?: any;
  setShowFilter?: any;
  handleSubmitFilter?: () => void;
  isClean?: boolean;
  setIsClean?: any;
  resDate?: any;
  setResDate?: any;
  endDate?: any;
  setEndDate?: any;
  resetInputs?: () => void;
  setPage: any;
  handleCheckData: (id: number) => void;
  filterTransactionMutation: any;
  accNo: string;
  setAccNo: (data: string) => void;
}

const Filter = (props: Props) => {
  const {
    bg,
    pageName,
    selectedAccount,
    // searchValue,
    btnId,
    paymentType,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    // handleSubmitFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    // resetInputs,
      handleCheckData,
      setPage,
    filterTransactionMutation,
    accNo,
      setAccNo
  } = props;
  const {
    t,
    options,
    focused,
    smallScreen,
    handlerChangeDateInput,
    onFocus,
    handleChangePaymentType,

    handleChangeClient,

    handleChangeVoen,

    handlerChangeFromAmount,

    handlerChangeToAmount,

    resDateRef,
    period,
    firstFocused,
    secondFocused,
    onFocusNext,
    onFocusEnd,
    handlerBlur,
    // endDate,
    nextDate,
    // resNextDate,
    // resEndDate,
    handlerNextDate,
    handlerEndDate,
    onChangePeriod,
      control,
      register,
    // selectedPeriod,
    errors,
    handleSubmit,
      handleSubmitFilter,
    resetAllInput,
      resetWithRequest,
    accOptions
  } = useFilter({
    selectedAccount,
    paymentType,
    btnId,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    handleCheckData,
    setPage,
    filterTransactionMutation
  });

  return (
    <>
      <Button
        color={'secondary'}
        sx={btnFilter(bg)}
        onClick={() => {
          setShowFilter(true);
        }}
      >
        <FilterIcon />
        {showCount && mainCount !== 0 && (
          <Box sx={notif}>
            <Typography sx={notifText}>{mainCount}</Typography>
          </Box>
        )}
      </Button>
      <Dialog
        open={showFilter}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <DialogTitle sx={dialogTitle}>
          <Typography sx={{ fontSize: '22px',fontWeight: '600' }}>{t('homePage.filter')}</Typography>
          <Button
            color={'secondary'}
            onClick={() => {
              setShowFilter(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent sx={dialogContent}>
          <form style={{display: 'contents'}} onSubmit={handleSubmit(handleSubmitFilter)}>
          {pageName !== 'payment-orders' && (
            <>
              <Box sx={dialogContentBoxes}>
                <Typography sx={inputHeader}>Hesab</Typography>
                <Select
                    styles={selectStyles}
                    isSearchable={false}
                    options={accOptions}
                    placeholder={'Hesab'}
                    components={{
                      IndicatorSeparator: () => null,
                      Option: OptionsWithIcon,
                    }}
                    value={accNo}
                    onChange={setAccNo}
                />
              </Box>
              <Box sx={dialogContentBoxes}>
                <Typography sx={inputHeader}>{t('homePage.trType')}</Typography>
                <Select
                  styles={selectStyles}
                  isSearchable={false}
                  options={options}
                  placeholder={t('homePage.trType')}
                  components={{
                    IndicatorSeparator: () => null,
                    Option: OptionsWithIcon,
                  }}
                  value={paymentType}
                  onChange={handleChangePaymentType}
                />
              </Box>
              <Box sx={dialogContentBoxes}>
                <Typography sx={inputHeader}>{t('homePage.rcName')}</Typography>
                <OutlinedInput
                  placeholder={t('homePage.rcName')}
                  sx={{ ...inputOutlined, '& .MuiOutlinedInput-input': { padding: '0px' } }}
                  value={client}
                  onChange={(e: any) => handleChangeClient(e)}
                />
              </Box>
              <Box sx={dialogContentBoxes}>
                <Typography sx={inputHeader}>{t('homePage.rcTaxId')}</Typography>
                <OutlinedInput
                  placeholder={t('homePage.rcTaxId')}
                  sx={{ ...inputOutlined, '& .MuiOutlinedInput-input': { padding: '0px' } }}
                  value={voen}
                  onChange={(e: any) => handleChangeVoen(e)}
                  inputProps={{
                    ...register('taxId'),
                    maxLength: 10,
                  }}
                />
                <FieldError error={errors.taxId}/>
              </Box>
            </>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {/*<CustomSelect*/}
            {/*  options={period}*/}
            {/*  rest={register('paymentPeriod')}*/}
            {/*  control={control}*/}
            {/*  title={t('homePage.paymentPeriod')}*/}
            {/*  placeholder={t('homePage.paymentPeriod')}*/}
            {/*  onChange={onChangePeriod}*/}
            {/*  value={selectedPeriod}*/}
            {/*  width={'100%'}*/}
            {/*/>*/}
            {/*{selectedPeriod?.value === '-1' && (*/}

              <>
                <Box sx={{display: "flex", gap:'8px',flexDirection: 'column'}}>
                  <Typography sx={{ fontSize: '15px', fontWeight: 400, lineHeight: '18px' }}>{t('homePage.paymentPeriod')}</Typography>
                  <Box sx={{ display: 'flex', gap: '16px' }}>
                    <OutlinedInput
                      inputProps={{ style: { paddingLeft: '12px' } }}
                      value={resNextDate}
                      onFocus={onFocusNext}
                      placeholder={t('homePage.fromDate')}
                      sx={inputOutlined}
                      startAdornment={
                        <InputAdornment sx={{ margin: '0px' }} position={'start'}>
                          <CalendarIcon sx={{ fill: 'transparent' }} />
                        </InputAdornment>
                      }
                    />
                    <OutlinedInput
                      inputProps={{ style: { paddingLeft: '12px' } }}
                      value={resEndDate}
                      onFocus={onFocusEnd}
                      placeholder={t('homePage.toDate')}
                      sx={inputOutlined}
                      startAdornment={
                        <InputAdornment sx={{ margin: '0px' }} position={'start'}>
                          <CalendarIcon sx={{ fill: 'transparent' }} />
                        </InputAdornment>
                      }
                    />
                  </Box>
                </Box>
                {firstFocused && (
                  <Box sx={{ position: 'fixed', zIndex: 1, mt: '75px' }}>
                    <DatePicker
                      selected={resDate}
                      onChange={(date) => {
                        handlerNextDate(date);
                      }}
                      inline
                      shouldCloseOnSelect={true}
                      onClickOutside={handlerBlur}
                      // style={{ position: 'absolute', top: '-70px' }}
                    />
                  </Box>
                )}
                {secondFocused && (
                  <Box sx={{ position: 'fixed', zIndex: 1, mt: '75px', ml: '87px' }}>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        handlerEndDate(date);
                      }}
                      inline
                      shouldCloseOnSelect={true}
                      onClickOutside={handlerBlur}
                    />
                  </Box>
                )}
              </>
            {/*)}*/}
          </Box>

          <Box sx={{ ...dialogContentBoxes, mb: '12px' }}>
            <Typography sx={inputHeader}>{t('homePage.amountRange')}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
              <AmountInput
                value={fromAmount}
                handleChange={handlerChangeFromAmount}
                placeholder={t('homePage.fromAmount')}
              />
              <AmountInput value={toAmount} handleChange={handlerChangeToAmount} placeholder={t('homePage.toAmount')} />
            </Box>
          </Box>
          {smallScreen ? (
            <Box sx={smallScreenBtnBox}>
              <Button type={"submit"}>{t('homePage.confirm')}</Button>
              {isClean && (
                <Button
                  color={'tertiary'}
                  sx={{ display: 'flex', gap: '12px', '& .MuiSvgIcon-root': { width: '22px', height: '22px' } }}
                  onClick={resetAllInput}
                >
                  <BinIcon sx={{ fill: 'transparent' }} />
                  {t('homePage.resetFilters')}
                </Button>
              )}
            </Box>
          ) : (
            <Box sx={btnsBox}>
              {isClean && (
                <Button

                  color={'tertiary'}
                  sx={{ display: 'flex', gap: '12px', '& .MuiSvgIcon-root': { width: '22px', height: '22px' } }}
                  onClick={resetAllInput}
                >
                  <BinIcon sx={{ fill: 'transparent' }} />
                  {t('homePage.resetFilters')}
                </Button>
              )}
              <Button type={"submit"} >{t('homePage.confirm')}</Button>
            </Box>
          )}
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Filter;
